import http from '@/utils/http'

export function login(data){
    return http.post('/sessions',data)
}
export function logout(params){
    return http.delete(`/sessions`,{params})
}
export function forgetPassword(data){
    return http.post('/forget_password',data)
}
export function sendActivationCode(data){
    return http.post('/send_activation_code',data)
}
export function getVerificationCode(){
    return http('/verification_code')
}
export function getActiveUser(params){
    return http('/active_user',{params})
}
